import { createFileRoute, Outlet } from "@tanstack/react-router";

/** Layout für Raid-Detail: Lesen (`~index` → `/raids/:id`) und Bearbeiten (`~edit`). */
export const Route = createFileRoute("/raids_/$raidId")({
  component: () => <Outlet />,
});
